module.exports = __webpack_public_path__ + "media/balcony.4846e7c9.svg";